import { compact, indexOf } from 'lodash';

import { isPipelineWithParent } from '@/core/pipeline';
import { isCellWithPipeline } from '@/core/cell';

import { getExplorationCell } from '@/core/exploration';

import { Exploration, Pipeline, TimeAggregationPeriod } from '../types';

export const pipelineColor = (index: number | undefined, colors: string[]) =>
  index !== undefined ? colors[index % colors.length] : undefined;

export const getParentPipelineColor = (exploration: Exploration, pipeline: Pipeline) => {
  if (!isPipelineWithParent(pipeline)) {
    return;
  }

  return getPipelineColorByPipelineId(exploration, pipeline.parentId);
};

export const getPipelineColor = (exploration: Exploration, pipeline: Pipeline) =>
  getPipelineColorByPipelineId(exploration, pipeline.pipelineId);

const getPipelineColorByPipelineId = (exploration: Exploration, pipelineId: string) => {
  const pipelineIds = compact(
    exploration.view.cells.map((cell) =>
      isCellWithPipeline(cell) ? cell.pipeline.pipelineId : undefined,
    ),
  );

  return indexOf(pipelineIds, pipelineId);
};

export const getPipelineColorByCellId = (exploration: Exploration, cellId: string) => {
  const cell = getExplorationCell(exploration, cellId);
  if (cell === undefined || !isCellWithPipeline(cell)) {
    return;
  }

  return getPipelineColor(exploration, cell.pipeline);
};

export const getTimeAggregationPeriodLabel = (precision: TimeAggregationPeriod) => {
  switch (precision) {
    case 'hour':
      return 'Hour';
    case 'day':
      return 'Day';
    case 'week':
      return 'Week';
    case 'day_of_week':
      return 'Day of Week';
    case 'month':
      return 'Month';
    case 'quarter':
      return 'Quarter';
    case 'year':
      return 'Year';
    default:
      return precision;
  }
};
